export function isDefault<T, I = T>(item: T, defaultItem: I): boolean {
  return Object.entries(defaultItem).every(
    ([key, value]) => item[key as keyof T] === value
  )
}
